const Wrapper = ({ children }) => <div className="text-lg flex w-full md:flex-row flex-col-reverse h-screen -md:h-auto -md:mt-12"> {children} </div>;

export default Wrapper;
